import { render, staticRenderFns } from "./BotSteamDataEditor.vue?vue&type=template&id=6770e3c0&"
import script from "./BotSteamDataEditor.vue?vue&type=script&lang=js&"
export * from "./BotSteamDataEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports